export default {
  state: {
    endPointConfig: '',
  },
}
